import React from 'react'

import { TabNavigation, TabPanel, Tabs } from '@/components'
import { Box, Container } from '@material-ui/core'
import { RegistersContainer } from './styles'

import { DriversList } from './drivers'
import { VehiclesList } from './vehicles'

// -----------------------------------------------

const REGISTER_TABS = [
  { value: 0, label: 'Motoristas' },
  { value: 1, label: 'Caminhões' },
]

// -----------------------------------------------

export default function RegistersPage() {
  return (
    <TabNavigation>
      <Container maxWidth="md">
        <Box
          display="flex"
          flexDirection="column"
          gridGap="0.5rem"
          paddingTop="2rem"
        >
          <Tabs tabs={REGISTER_TABS} />

          <RegistersContainer>
            <TabPanel index={0}>
              <DriversList />
            </TabPanel>

            <TabPanel index={1}>
              <VehiclesList />
            </TabPanel>
          </RegistersContainer>
        </Box>
      </Container>
    </TabNavigation>
  )
}
